<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / Inventory / <a href="/inventory/contacts">My Contacts</a> / Imports
    </nav>
    <div class="container">
      <div v-if="!vesselId" class="jumbotron">
        <h1>Contact Imports</h1>
        <p>To import contacts, you must first complete the onboarding process.</p>
      </div>
      <template v-else>
        <div class="jumbotron">
          <h1>Contact Imports</h1>
          <div class="well">
            <p>All of your contact imports are listed below. Choose one to see more detail.</p>
          </div>
        </div>
        <contact-imports-table :timezone="timezone" :vessel-id="vesselId" :user-id="userId"></contact-imports-table>
      </template>
    </div>
  </div>
</template>

<script>
import ContactImportsTable from '../components/contact/import/ContactImportsTable';

export default {
  name: 'contact-imports-list-page',
  components: {ContactImportsTable},
  props: {
    timezone: {
      type: String,
      required: true,
    },
    vesselId: {
      type: Number,
      required: true,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
};
</script>
